﻿import React from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { AdminLocationSearchCriteria } from "../../../types/model/criteria/location/AdminLocationSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  AdminLocationSortByType,
  AdminLocationSortParams
} from "../../../types/model/params/sortParams/AdminLocationSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundTextInput,
  BoundStateAutocomplete,
  BoundYesNoSelect,
  BoundSubscriptionTypeSelect,
  BoundLocationDisplayStatusSelect
} from "../../common/inputs/boundInputs";

export interface AdminLocationsSearchParams extends AdminLocationSearchCriteria, AdminLocationSortParams, PageableParams, BoundSearchQuery {}

export interface AdminLocationsSortFilterProps {
  query: AdminLocationsSearchParams;
  onChange: (newQuery: AdminLocationsSearchParams) => void;
}

const AdminLocationsSortFilter = ({
  query,
  onChange
}: AdminLocationsSortFilterProps) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminLocationsSearchParams>
          label="Location Name"
          requestUrl={optionsEndpoints.admin.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminLocationsSearchParams>
          label="Company Name"
          requestUrl={optionsEndpoints.admin.account.supplier}
          name="accountId"
          value={query?.accountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminLocationsSearchParams>
          label="Phone Number"
          name="phoneNumber"
          value={query?.phoneNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminLocationsSearchParams>
          label="City"
          name="city"
          value={query?.city}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundStateAutocomplete<AdminLocationsSearchParams>
          name="state"
          value={query?.state}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundYesNoSelect<AdminLocationsSearchParams>
          label="Instant Approval"
          name="instantApproval"
          value={query?.instantApproval}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundYesNoSelect<AdminLocationsSearchParams>
          label="Allow Daily Booking"
          name="allowsDailyBookings"
          value={query?.allowsDailyBookings}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundYesNoSelect<AdminLocationsSearchParams>
          label="Account Activated"
          name="activated"
          value={query?.activated}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundSubscriptionTypeSelect<AdminLocationsSearchParams>
          name="subscriptionType"
          value={query?.subscriptionType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundLocationDisplayStatusSelect<AdminLocationsSearchParams>
          label="Status"
          name="status"
          value={query?.status}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<AdminLocationsSearchParams, AdminLocationSortByType>
          query={query}
          defaultSortBy="COMPANY_NAME"
          defaultSortDir="asc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { AdminLocationsSortFilter };
